export function formatAddress(address: string, offset = 3) {
  return `${address.slice(0, offset + 2)}...${address.slice(-offset)}`
}
